import { useState } from 'react';
import CountUp from 'react-countup' 
import ScrollTigger from 'react-scroll-trigger'

const Number = ({ n }) => {
    const [counterOn, setCounterOn] = useState(false);
  
    return (
      <ScrollTigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
        {counterOn && <CountUp start={0} end={n} duration={2} />}
      </ScrollTigger>
    );
  }

export default Number


